import PropTypes from '../../_util/vue-types';

export default {
  name: 'ColumnGroup',
  props: {
    title: PropTypes.any
  },
  isTableColumnGroup: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-table/src/ColumnGroup.js
// module id = null
// module chunks = 